import AutoReplace from 'slate-auto-replace';
import isHotkey from 'is-hotkey';
import BlockTypes from '../../types/BlockTypes';
import StyleTypes from '../../types/StyleTypes';
export default function makeMarkdownInlineShortcut(searchRegexp, replaceRegexpOrFunction, type) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'shift?+space' : _ref$trigger,
      _ref$byKey = _ref.byKey,
      byKey = _ref$byKey === void 0 ? false : _ref$byKey;

  var isTrigger = isHotkey(trigger, {
    byKey: byKey
  });
  return AutoReplace({
    trigger: function trigger(event, editor) {
      if (!isTrigger(event) || editor.isVoid(editor.value.startBlock) || editor.isVoid(editor.value.endBlock) || editor.isActiveBlock(BlockTypes.CODE) || editor.isActiveMark(StyleTypes.CODE)) {
        return false;
      }

      return true;
    },
    before: searchRegexp,
    change: function change(editor, event, matches) {
      if (typeof replaceRegexpOrFunction === 'function') {
        return replaceRegexpOrFunction(editor, event, matches);
      }

      var foundText = matches.before[0];
      var replacedText = replaceRegexpOrFunction.exec(foundText)[1];
      return editor.addMark(type).insertText(replacedText).removeMark(type).insertText(' ');
    }
  });
}